$shm_hitalama_profile_page $shm_hitalama_guide_page
	title \Личный кабинет
	help_section \profile
	tools /
		<= Exit_header $mol_button_minor
			title \Выйти из Хиталамы
			click? <=> exit? null
	profiles $shm_hitalama_profile_dict
	message_login_empty \Логин не может быть пустым
	message_login_exists \Пользователь "{login}" уже существует
	message_saved \Сохранено
	body /
		<= Avatar_label $mol_labeler
			title \Аватар
			content / <= Avatar_tools $mol_view
				sub /
					<= Avatar_upload $shm_hitalama_file_attach
						files? <=> avatar_files? /File
						sub /
							<= Avatar_preview $shm_hitalama_profile_badge
								avatar_uri <= avatar_uri \
								name <= login \
							^
					^ avatar_delete_visible / <= Avatar_delete $mol_button_minor
						title \Удалить аватар
						click? <=> avatar_delete? null
		<= Login_label $mol_labeler
			title \Имя
			content /
				<= Login $mol_string
					value? <=> login? \
					submit? <=> save? null
		<= Login_tools $mol_view
			sub /
				<= Save $mol_button_major
					title \Сохранить
					click? <=> save? null
					enabled? <=> save_enabled? true
		<= Secret_label $mol_labeler
			title \Секретный ключ
			content /
				<= Secret_copy $shm_button_copy
					title \Скопировать секретный ключ
					text <= secret_key \
		<= Client_label $mol_labeler
			title \ID клиента
			content /
				<= Client_copy $shm_button_copy
					title <= client_id \
					hint \Скопировать ID клиента
					text <= client_id \
		<= Message $mol_text
			attr *
				^
				status <= message_status \
			text <= message? \
